import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaMoneyBillWave, FaRegCreditCard } from "react-icons/fa";
import axios from "axios";
import useAuth from "../../composant_reutilisable/useAuth";
import Sidebar from "../../composant_reutilisable/sidebar";
import Navbar from "../../composant_reutilisable/navbar";
import Pas_acces from "../../composant_reutilisable/pas_acces";

const Historique_paiement = ({ titre }) => {
    useAuth();
    const [paiements, setPaiements] = useState([]);
    const [selectedPaiement, setSelectedPaiement] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: "date_paiement", direction: "descending" });
    const [searchTerm, setSearchTerm] = useState("");
    const [filtreStatut, setFiltreStatut] = useState("tous");
    const [filtreTypePaiement, setFiltreTypePaiement] = useState("");
    const [alert, setAlert] = useState({ message: "", type: "" });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [accesGroupe, setAccesGroupe] = useState([]);
    const user_id = localStorage.getItem("IDDDD");
    const typePaiementOptions = [
        { value: '', label: 'Tous des droits' },
        { value: 'droit_tour', label: 'Droit de tour' },
        { value: 'droit_chargement', label: 'Droit de chargement' }
    ];


    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Historique des paiements";
            verifGroupe();
            fetchPaiements();
        }
    }, [user_id]);

    const fetchPaiements = async () => {
        try {
            const params = new URLSearchParams({
                page: currentPage,
                per_page: itemsPerPage,
                type_paiement: filtreTypePaiement,
                search: searchTerm
            }).toString();

            const response = await axios.get(`${process.env.REACT_APP_HOTE}/historique-paiements/?${params}`);
            console.log("Données reçues:", response.data);

            let paiementsData = [];

            if (Array.isArray(response.data)) {
                paiementsData = response.data;
            } else if (response.data && typeof response.data === 'object') {
                if (response.data.paiements && Array.isArray(response.data.paiements)) {
                    paiementsData = response.data.paiements;
                } else {
                    paiementsData = Object.values(response.data);
                }
            }

            if (paiementsData.length > 0) {
                setPaiements(paiementsData);
            } else {
                console.error("Aucune donnée de paiement valide trouvée");
                setPaiements([]);
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            setPaiements([]);
            showAlert("Erreur lors du chargement des paiements", "danger");
        }
    };

    const verifGroupe = async () => {
        const groupe = localStorage.getItem("groupe");
        try {
            const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
            if (response.status === 200) {
                const cleanedAccessArray = response.data.acces
                    .map(item => item.acces ? item.acces.replace(/[\[\]']/g, "").trim().split(",").map(access => access.trim()) : [])
                    .flat();
                setAccesGroupe(cleanedAccessArray);
                localStorage.setItem("accesGroupe", JSON.stringify(cleanedAccessArray));
            }
        } catch (error) {
            console.error('Erreur lors de la vérification du groupe', error);
        }
    };

    if ( accesGroupe.includes("Paiement")) {
        return (
            <Pas_acces />
        );
    }

    // const handleDeletePaiement = async () => {
    //     if (selectedPaiement) {
    //         try {
    //             await axios.delete(`${process.env.REACT_APP_HOTE}/supprimer-paiement/${selectedPaiement.paiement_id}/`);
    //             showAlert("Paiement supprimé avec succès !");
    //             fetchPaiements();
    //         } catch (error) {
    //             console.error("Erreur lors de la suppression", error);
    //             showAlert("Erreur lors de la suppression", "danger");
    //         } finally {
    //             setShowDeleteModal(false);
    //         }
    //     }
    // };

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
        setTimeout(() => setAlert({ message: "", type: "" }), 3000);
    };

    const handleSort = (key) => {
        setSortConfig({
            key,
            direction: sortConfig.key === key && sortConfig.direction === "ascending" ? "descending" : "ascending"
        });
    };

    const filteredPaiements = paiements.filter(paiement => {
        const matchesSearch =
            (paiement.camion && paiement.camion.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (paiement.reference && paiement.reference.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (paiement.utilisateur && paiement.utilisateur.toLowerCase().includes(searchTerm.toLowerCase()));

        return matchesSearch;
    });

    const sortedPaiements = [...filteredPaiements].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === "ascending" ? -1 : 1;
        if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === "ascending" ? 1 : -1;
        return 0;
    });

    const indexOfLastPaiement = currentPage * itemsPerPage;
    const indexOfFirstPaiement = indexOfLastPaiement - itemsPerPage;
    const currentPaiements = sortedPaiements.slice(indexOfFirstPaiement, indexOfLastPaiement);
    const totalPages = Math.ceil(sortedPaiements.length / itemsPerPage);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(amount);
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="d-flex align-items-center">
                            <FaRegCreditCard size={25} className="mr-2" /> Historique des paiements
                        </h2>
                        <div className="d-flex justify-content-between align-items-center">
                        <small>Suivi de tous les paiements effectués sur la plateforme.</small>
                        <small id="hbreadcrumb" className="d-flex justify-content-end">
                                        <ol className="breadcrumb custom-breadcrumb">
                                          <li className="breadcrumb-item custom-breadcrumb-item">
                                            <Link to={`/Menu`}> Accueil</Link>
                                          </li>
                                          <li className="breadcrumb-item custom-breadcrumb-item active">
                                            <Link to={`/Gestion-des-tours`}> Gestion des tours</Link>
                                          </li>
                                          <li className="breadcrumb-item custom-breadcrumb-item">
                                            {/* <Link to={`/Gestion-des-tours-national`}> Gestion des tours nationaux</Link> */}
                                            Historique des paiements
                                          </li>
                                        </ol>
                                      </small>
                    </div>
                    </div>
                </div>

                <div className="mt-3">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
                        <h5>Liste des transactions</h5>
                        <div className="d-flex flex-column flex-sm-row flex-wrap mt-3 mt-md-0" style={{ gap: "10px" }}>
                            <div className="d-flex">
                                <button className="btn btn-success mr-2">
                                    <FaPlus /> Exporter
                                </button>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type}`}>{alert.message}</div>
                    )}

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox">
                                <div className="ibox-content">
                                    <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: "10px" }}>
                                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={itemsPerPage}
                                                onChange={(e) => {
                                                    setItemsPerPage(Number(e.target.value));
                                                    setCurrentPage(1);
                                                }}
                                            >
                                                <option value={10}>10</option>
                                                <option value={20}>20</option>
                                                <option value={50}>50</option>
                                            </select>

                                            <select
                                                className="form-select bg-default p-1"
                                                style={{
                                                    width: "auto",
                                                    border: "1px black solid",
                                                    borderRadius: "5px",
                                                }}
                                                value={filtreTypePaiement}
                                                onChange={(e) => setFiltreTypePaiement(e.target.value)}
                                            >
                                                {typePaiementOptions.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <input
                                            type="text"
                                            placeholder="Rechercher..."
                                            className="form-control"
                                            style={{ maxWidth: "150px", width: "100%" }}
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        <table
                                            className="footable table table-stripped footable-loaded tablet breakpoint"
                                            data-page-size="8"
                                            data-filter="#filter"
                                            style={{ fontSize: "12px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell"
                                                        onClick={() => handleSort("camion")}
                                                        style={{ width: "10%", minWidth: "100px" }}
                                                    >
                                                        Camion
                                                        {sortConfig.key === "camion"} {(sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell  align-middle"
                                                        onClick={() => handleSort("reference")}
                                                        style={{ width: "15%", minWidth: "150px" }}
                                                    >
                                                        Transaction
                                                        {sortConfig.key === "reference"} {(sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center  align-middle"
                                                        onClick={() => handleSort("montant")}
                                                        style={{ width: "15%", minWidth: "80px" }}
                                                    >
                                                        Montant
                                                        {sortConfig.key === "montant"} {(sortConfig.direction === "ascending" ? (
                                                                <FaSortAmountUp />
                                                            ) : (
                                                                <FaSortAmountDown />
                                                            ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("mode_paiement")}
                                                        style={{ width: "12%", minWidth: "100px" }}
                                                    >
                                                        Mode de paiement
                                                        {sortConfig.key === "mode_paiement"} {(sortConfig.direction === "ascending" ? (
                                                            <FaSortAmountUp />
                                                        ) : (
                                                            <FaSortAmountDown />
                                                        ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap text-center d-none d-md-table-cell"
                                                        onClick={() => handleSort("date_paiement")}
                                                        style={{ width: "15%", minWidth: "100px" }}
                                                    >
                                                        Date
                                                        {sortConfig.key === "date_paiement"} {(sortConfig.direction === "ascending" ? (
                                                            <FaSortAmountUp />
                                                        ) : (
                                                            <FaSortAmountDown />
                                                        ))}
                                                    </th>
                                                    <th
                                                        className="text-secondary text-wrap d-none d-md-table-cell text-center align-middle"
                                                        onClick={() => handleSort("status")}
                                                        style={{ width: "10%", minWidth: "80px" }}
                                                    >
                                                        Statut
                                                        {sortConfig.key === "status"} {(sortConfig.direction === "ascending" ? (
                                                            <FaSortAmountUp />
                                                        ) : (
                                                            <FaSortAmountDown />
                                                        ))}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentPaiements && currentPaiements.length > 0 ? (
                                                    currentPaiements.map((paiement) => (
                                                        <tr
                                                            key={paiement.paiement_id}
                                                            onClick={() => setSelectedPaiement(paiement)}
                                                            className={`bg-white ${selectedPaiement?.paiement_id === paiement.paiement_id ? "bg-success text-white" : ""}`}
                                                        >
                                                            <td className="" style={{ padding: "0.5rem" }}>
                                                                <div className="fw-semibold">{paiement.camion}</div>
                                                            </td>
                                                            <td
                                                                className=""
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="text-dark">{paiement.reference}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className="fw-semibold">{formatCurrency(paiement.montant)}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{paiement.mode_paiement}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span>{paiement.date_paiement}</span>
                                                            </td>
                                                            <td
                                                                className="d-none d-md-table-cell text-center align-middle"
                                                                style={{ padding: "0.5rem" }}
                                                            >
                                                                <span className={`badge ${paiement.status === 'Terminé' ? 'bg-primary' :
                                                                    paiement.status === 'Échoué' ? 'bg-danger' : 'bg-warning'
                                                                    }`}>
                                                                    {paiement.status}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            Aucun paiement trouvé
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination Controls */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="dataTables_info" role="status" aria-live="polite">
                                            {sortedPaiements.length === 0
                                                ? "Aucun élément à afficher"
                                                : `Élément ${indexOfFirstPaiement + 1} à ${Math.min(indexOfLastPaiement, sortedPaiements.length)} sur ${sortedPaiements.length}`}
                                        </div>

                                        <div>
                                            {Array.from({ length: totalPages }, (_, index) => (
                                                <button
                                                    key={index + 1}
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    className={`btn ${currentPage === index + 1 ? "btn-default" : "btn-light"
                                                        } mx-1`}
                                                >
                                                    {index + 1}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default Historique_paiement;